import { PickupAddress, PickupAddressResponse } from '../types/address';
import { api } from './api';

export const addressService = {
  // GET pickup addresses (POST as per backend)
  async fetch(userId: string): Promise<PickupAddressResponse> {
    const res = await api.get<PickupAddressResponse>(
      `/address/users/${userId}/pickup_address`
    );
    return res.data;
  },

  // ADD pickup address (POST)
  async save(
    userId: string,
    payload: PickupAddress
  ): Promise<{ success: boolean; message?: string }> {
    const res = await api.post(
      `/address/users/${userId}/pickup_address`,
      payload
    );
    return res.data;
  },

  // UPDATE pickup address (PUT)
  async update(
    userId: string,
    pickupId: string | number,
    payload: PickupAddress
  ): Promise<{ success: boolean; message?: string }> {
    const res = await api.put(
      `/address/users/${userId}/${pickupId}/pickup_address`,
      payload
    );
    return res.data;
  },

  // DELETE pickup address (DELETE)
  async delete(
    userId: string,
    pickupId: string | number
  ): Promise<{ success: boolean; message?: string }> {
    const res = await api.delete(
      `/address/users/${userId}/${pickupId}/pickup_address`
    );
    return res.data;
  },

  // ADD delivery address (POST)
  async saveDelivery(
    userId: string,
    payload: PickupAddress
  ): Promise<{ success: boolean; message?: string }> {
    const res = await api.post(
      `/address/users/${userId}/delivery_address`,
      payload
    );
    return res.data;
  },

  // ADD b2b pickup address
  async saveB2bPickup(
    payload: any
  ): Promise<{ success: boolean; message?: string; data?: any }> {
    const res = await api.post(
      `/b2b/addresses/pickup`,
      payload
    );
    return res.data;
  },

  // ADD b2b delivery address
  async saveB2bDelivery(
    payload: any
  ): Promise<{ success: boolean; message?: string; data?: any }> {
    const res = await api.post(
      `/b2b/addresses/delivery`,
      payload
    );
    return res.data;
  },
};
